module.exports = __webpack_public_path__ + "img/blue_163.0fecee18.png";